"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationPointAddressType = void 0;
var LocationPointAddressType;
(function (LocationPointAddressType) {
    LocationPointAddressType[LocationPointAddressType["Airport"] = 0] = "Airport";
    LocationPointAddressType[LocationPointAddressType["Port"] = 1] = "Port";
    LocationPointAddressType[LocationPointAddressType["Train"] = 2] = "Train";
    LocationPointAddressType[LocationPointAddressType["AirportTransfer"] = 3] = "AirportTransfer";
})(LocationPointAddressType || (exports.LocationPointAddressType = LocationPointAddressType = {}));
//# sourceMappingURL=LocationPointAddressType.js.map